// =========================
// Initial Form State Factory
// =========================
export const createInitialFormData = () => ({
    // =========================
    // STEP 1
    // =========================
    PROFILE_CATEGORY: "",

    // =========================
    // COMPANY
    // =========================
    COMPANYID: 0,
    COMPANY_NAME : "",
    COMPANYLOGO: "",
    POWERED_BY: "shipez.ai",

    // =========================
    // PROFILE
    // =========================
    PROFILE_FIRSTNAME: "",
    PROFILE_LASTNAME: "",
    PROFILE_EMAILID: "",
    PROFILE_USERNAME: "",
    PROFILE_PASSWORD: "",
    CONFIRM_PASSWORD: "",

    PROFILE_PHONE: "",
    PROFILE_COUNTRY_CODE: "+1",

    PROFILE_ADDRESS1: "",
    PROFILE_ADDRESS2: "",
    PROFILE_ADDRESS_PRINT: "",

    PROFILE_CITY: "",
    PROFILE_REGION: "",
    PROFILE_COUNTRY: "USA",
    PROFILE_ZIPCODE: "",

    LICENCE_NUMBER: "",

    // =========================
    // FILE
    // =========================
    FILEDATA: null,

    // =========================
    // ACTION
    // =========================
    ACTION_BY: "admin",

    // =========================
    // MODULE SELECTION (UI STATE - IMPORTANT)
    // =========================
    SUBSCRIBED_BASEMODULE_DETAILS: [],

    SUBSCRIBED_BASEMODULE_DETAILS_JSON: ""
});